import { useContext, useEffect, useRef, useState } from 'react'

import AppContext from '@/common/context/app.context'
import { getActiveLanguage, getLanguagesWithDefaultFirst } from '@/configuration/helpers/helpers'

const useLanguageTextInput = ({ languages, value, onChange, validateEmptyOnBlur, externalErrorLanguages }) => {
  const { info } = useContext(AppContext)
  const orderedLanguages = getLanguagesWithDefaultFirst(languages, info.selectedStore.default_language)
  const [textLanguage, setTextLanguage] = useState(getActiveLanguage(orderedLanguages, externalErrorLanguages))
  const [emptyErrors, setEmptyErrors] = useState({})
  const previousErrorLanguages = useRef(externalErrorLanguages)

  useEffect(() => {
    const newErrorLanguages = externalErrorLanguages.filter(
      language => !previousErrorLanguages.current.includes(language)
    )

    previousErrorLanguages.current = externalErrorLanguages

    if (newErrorLanguages.length === 0 || externalErrorLanguages.includes(textLanguage)) return

    setTextLanguage(getActiveLanguage(orderedLanguages, newErrorLanguages))
  }, [externalErrorLanguages, textLanguage, orderedLanguages])

  const hasError = language => {
    return Boolean(emptyErrors?.[language]) || externalErrorLanguages.includes(language)
  }

  const handleChange = e => {
    onChange(e.target.value, textLanguage)
  }

  const handleBlur = () => {
    if (!validateEmptyOnBlur) {
      return
    }

    languages.forEach(lang => {
      setEmptyErrors(prev => ({ ...prev, [lang]: !value?.[lang] }))
    })
  }

  return { orderedLanguages, textLanguage, setTextLanguage, hasError, handleChange, handleBlur }
}

export default useLanguageTextInput
